<template>
  <div v-if="$store.getters.suggestedHeight > 0">
    <div class="configurator__label u-display-flex u-align-items-center u-justify-content-space-between">
      <div class="u-font-weight-700" v-if="($store.getters.shelvingsSwitch) || (!($store.getters.shelvingsSwitch) && computedAccessoires.posts.filter((post) => ((post.type == 'adjoiners')||(post.type == 'flange'))&&(post.amount > 0)).length > 0)">
        {{ $t('configurator.results.chosen_accessories') }}
      </div>
      <div v-if="$store.getters.bestSystem || $store.getters.chosenItems">
        <ModifyAccessoires :button-label="buttonLabel"></ModifyAccessoires>
      </div>
    </div>
    <div v-if="isMobile">
      <table v-if="$store.getters.shelvingsSwitch && computedAccessoires.accessoires.filter((acc) => acc.amount > 0)" class="chosen-results first-filter">
        <thead>
          <th class="results__label u-font-weight-600 u-text-transform-uppercase">{{ $t('system.name_and_article') }}</th>
          <th class="results__label u-font-weight-600 u-text-transform-uppercase">{{ $t('system.amount') }}</th>
        </thead>
        <tbody>
          <tr v-for="(accessory, index) in computedAccessoires.accessoires.filter((acc) => acc.amount > 0).concat(computedAccessoires.posts.filter((post) => post.amount > 0))" v-bind:key="index">
            <td>
              <span class="u-display-block"><small>{{ accessory.SAP_Code }}</small></span>
              <span class="u-display-block">{{ accessory.name }}</span>
            </td>
            <td>{{ accessory.amount}}</td>
          </tr>
        </tbody>
      </table>
      <table v-if="!($store.getters.shelvingsSwitch) && computedAccessoires.posts.filter((post) => ((post.type == 'adjoiners')||(post.type == 'flange'))&&(post.amount > 0))" class="chosen-results second-filter">
        <thead>
          <th class="results__label u-font-weight-600 u-text-transform-uppercase">{{ $t('system.name_and_article') }}</th>
          <th class="results__label u-font-weight-600 u-text-transform-uppercase">{{ $t('system.amount') }}</th>
        </thead>
        <tbody>
          <tr v-for="(accessory, index) in computedAccessoires.posts.filter((post) => ((post.type == 'adjoiners')||(post.type == 'flange'))&&(post.amount > 0))" v-bind:key="index">
            <td>
              <span class="u-display-block"><small>{{ accessory.SAP_Code }}</small></span>
              <span class="u-display-block">{{ accessory.name }}</span>
            </td>
            <td>{{ accessory.amount}}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <div v-else>
      <table v-if="$store.getters.shelvingsSwitch && computedAccessoires.accessoires.filter((acc) => acc.amount > 0)" class="chosen-results first-filter">
        <thead>
          <th class="results__label u-font-weight-600 u-text-transform-uppercase">{{ $t('system.name') }}</th>
          <th class="results__label u-font-weight-600 u-text-transform-uppercase">{{ $t('system.article') }}</th>
          <th class="results__label u-font-weight-600 u-text-transform-uppercase">{{ $t('system.amount') }}</th>
        </thead>
        <tbody>
          <tr v-for="(accessory, index) in computedAccessoires.accessoires.filter((acc) => acc.amount > 0).concat(computedAccessoires.posts.filter((post) => post.amount > 0))" v-bind:key="index">
            <td>{{ accessory.name }}</td>
            <td>{{ accessory.SAP_Code }}</td>
            <td>{{ accessory.amount}}</td>
          </tr>
        </tbody>
      </table>
      <table v-if="!($store.getters.shelvingsSwitch) && computedAccessoires.posts.filter((post) => ((post.type == 'adjoiners')||(post.type == 'flange'))&&(post.amount > 0)).length > 0" class="chosen-results second-filter">
        <thead>
          <th class="results__label u-font-weight-600 u-text-transform-uppercase">{{ $t('system.name') }}</th>
          <th class="results__label u-font-weight-600 u-text-transform-uppercase">{{ $t('system.article') }}</th>
          <th class="results__label u-font-weight-600 u-text-transform-uppercase">{{ $t('system.amount') }}</th>
        </thead>
        <tbody>
          <tr v-for="(accessory, index) in computedAccessoires.posts.filter((post) => ((post.type == 'adjoiners')||(post.type == 'flange'))&&(post.amount > 0))" v-bind:key="index">
            <td>{{ accessory.name }}</td>
            <td>{{ accessory.SAP_Code }}</td>
            <td>{{ accessory.amount}}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <div v-if="['view', 'tview'].includes($store.getters.coldroomSystem) && computedAccessoires.lighting.filter((light) => light.amount > 0)">
      <div class="configurator__label">{{ $t('configurator.results.lights_number') }}</div>
      <table v-if="isMobile" class="chosen-results third-filter">
        <thead>
          <th class="results__label u-font-weight-600 u-text-transform-uppercase">{{ $t('system.name_and_article') }}</th>
          <th class="results__label u-font-weight-600 u-text-transform-uppercase">{{ $t('system.amount') }}</th>
        </thead>
        <tbody>
          <tr v-for="(accessory, index) in computedAccessoires.lighting.filter((light) => light.amount > 0)" v-bind:key="index">
            <td>
              <span class="u-display-block"><small>{{ accessory.SAP_Code }}</small></span>
              <span class="u-display-block">{{ accessory.name }}</span>
            </td>
            <td>{{ accessory.amount}}</td>
          </tr>
        </tbody>
      </table>
      <table v-else class="chosen-results third-filter">
        <thead>
          <th class="results__label u-font-weight-600 u-text-transform-uppercase">{{ $t('system.name') }}</th>
          <th class="results__label u-font-weight-600 u-text-transform-uppercase">{{ $t('system.article') }}</th>
          <th class="results__label u-font-weight-600 u-text-transform-uppercase">{{ $t('system.amount') }}</th>
        </thead>
        <tbody>
          <tr v-for="(accessory, index) in computedAccessoires.lighting.filter((light) => light.amount > 0)" v-bind:key="index">
            <td>{{ accessory.name }}</td>
            <td>{{ accessory.SAP_Code }}</td>
            <td>{{ accessory.amount}}</td>
          </tr>
        </tbody>
      </table>
    </div>

  </div>
</template>

<style lang="scss">
</style>

<script>
import ModifyAccessoires from "./ModifyAccessoires.vue";
import accessoires from "@/assets/accessoires.json";

export default {
  props: [
    "systems",
    "label",
    "changeAcessory"
  ],
  components: {
    ModifyAccessoires,
  },
  data: function () {
    return {
      isMobile: false
    };
  },
  beforeDestroy () {
    if (typeof window === 'undefined')  {
      return window.removeEventListener('resize', this.onResize, { passive: true })
    }
  },
  mounted () {
    this.onResize();
    window.addEventListener('resize', this.onResize, { passive: true });
  },
  beforeMount() {
    this.$store.commit(
      "setComputedAccessoires",
      accessoires[this.$store.state.coldroomSystem][this.$store.state.color][
        this.$store.state.article.slice(-2)
      ]
    );
  },
  methods: {
    onResize () {
      this.isMobile = window.innerWidth < 720
    }
  },
  computed: {
    buttonLabel: {
      get () {
        if (this.label) {
          return this.label;
        } else if (this.changeAcessory) {
          return this.changeAcessory;
        } else {
          return null;
        }
      }
    },
    computedAccessoires: {
      get() {
        //// initialize
        let systems = this.systems;
        let computedAccessoires = accessoires[this.$store.state.coldroomSystem][this.$store.state.color][
          this.$store.state.article.slice(-2)];
        //// calculate basic data, like number of doors
        const doors = (accumulator, currentValue) =>
          accumulator + currentValue["amount"] * currentValue["doors"];
        let numberOfDoors = systems.reduce(doors, 0);
        this.$store.commit("setNumberOfDoors", numberOfDoors)
        const oneDoor = (accumulator, currentValue) =>
          currentValue["doors"] == 1
            ? accumulator + currentValue["amount"]
            : accumulator;
        let numberOfOneDoorSystems = systems.reduce(oneDoor, 0);
        const twoDoor = (accumulator, currentValue) =>
          currentValue["doors"] == 2
            ? accumulator + currentValue["amount"]
            : accumulator;
        let numberOfTwoDoorSystems = systems.reduce(twoDoor, 0);
        //Number of double shelves needed if config set to double shelves
        const doubleShelvesReducer = (accumulator, currentValue) =>
          accumulator +
          Math.floor(currentValue["doors"] / 2) * currentValue["amount"];
        let doubleShelvesNeeded = systems.reduce(doubleShelvesReducer, 0);
        //Number of single shelves needed if config set to double shelves
        const singleShelvesReducer = (accumulator, currentValue) =>
          currentValue["doors"] % 2 == 1
            ? accumulator + currentValue["amount"]
            : accumulator;
        let singleShelvesNeeded = systems.reduce(singleShelvesReducer, 0);
        //Set height specifically for manual config, since it can change
        let chosenHeight = systems[0].Height

        //// Shelves
        // Set everything back to 0
        var i;
        for (i = 0; i < computedAccessoires.accessoires.length; i++)
          this.$set(computedAccessoires.accessoires[i], "amount", 0);
        for (i = 0; i < computedAccessoires.posts.length; i++)
          this.$set(computedAccessoires.posts[i], "amount", 0);
        // Set matching shelves to correct amount
        const findMatchingShelvesSingle = (element) =>
          {
            if (this.$store.getters.shelvesWirePlate=='plate'){
              return element.type == "shelves" &&
              element.plate_wire == this.$store.getters.shelvesWirePlate &&
              element.front_back == this.$store.getters.postsFrontBack &&
              element.single_double == "single";
            } else {
              return element.type == "shelves" &&
              element.plate_wire == this.$store.getters.shelvesWirePlate &&
              element.single_double == "single";
            }
          }
        const findMatchingShelvesDouble = (element) =>
          {
            if (this.$store.getters.shelvesWirePlate == 'plate'){
              return element.type == "shelves" &&
              element.plate_wire == this.$store.getters.shelvesWirePlate &&
              element.front_back == this.$store.getters.postsFrontBack &&
              element.single_double == "double";
            } else {
              return element.type == "shelves" &&
              element.plate_wire == this.$store.getters.shelvesWirePlate &&
              element.single_double == "double";
            }
          }
        //First classic
        if (this.$store.state.coldroomSystem == "classic") {
           // Special case of 45, since it has no single shelves
          if (['45'].includes(this.$store.state.article.slice(-2))) {
            this.$set(
                computedAccessoires.accessoires[
                  computedAccessoires.accessoires.findIndex(
                    findMatchingShelvesDouble
                  )
                ],
                "amount",
                doubleShelvesNeeded * this.$store.state.shelvesPerDoor
              );
          // Special case of 90, since it uses 45 double shelves
          }
          else if (['90'].includes(this.$store.state.article.slice(-2))){
              this.$set(
                computedAccessoires.accessoires[
                  computedAccessoires.accessoires.findIndex(
                    findMatchingShelvesDouble
                  )
                ],
                "amount",
                numberOfDoors * this.$store.state.shelvesPerDoor
              );
          } else {
            if (this.$store.state.shelvesSingleDouble == "double") {
              this.$set(
                computedAccessoires.accessoires[
                  computedAccessoires.accessoires.findIndex(
                    findMatchingShelvesDouble
                  )
                ],
                "amount",
                doubleShelvesNeeded * this.$store.state.shelvesPerDoor
              );
              this.$set(
                computedAccessoires.accessoires[
                  computedAccessoires.accessoires.findIndex(
                    findMatchingShelvesSingle
                  )
                ],
                "amount",
                singleShelvesNeeded * this.$store.state.shelvesPerDoor
              );
            } else if (this.$store.state.shelvesSingleDouble == "single") {
              this.$set(
                computedAccessoires.accessoires[
                  computedAccessoires.accessoires.findIndex(
                    findMatchingShelvesSingle
                  )
                ],
                "amount",
                numberOfDoors * this.$store.state.shelvesPerDoor
              );
            }
          }
        }
        // Now View/T.View
        else {
          // Special case of 45, since it has no single shelves
          if (this.$store.state.article.slice(-2) == "45") {
            this.$set(
                computedAccessoires.accessoires[
                  computedAccessoires.accessoires.findIndex(
                    findMatchingShelvesDouble
                  )
                ],
                "amount",
                numberOfTwoDoorSystems * this.$store.state.shelvesPerDoor + Math.floor(numberOfOneDoorSystems / 2) * this.$store.state.shelvesPerDoor
              );
            } else {
            if (this.$store.state.shelvesSingleDouble == "double") {
              this.$set(
                computedAccessoires.accessoires[
                  computedAccessoires.accessoires.findIndex(
                    findMatchingShelvesSingle
                  )
                ],
                "amount",
                (numberOfOneDoorSystems % 2) * this.$store.state.shelvesPerDoor
              );
              this.$set(
                computedAccessoires.accessoires[
                  computedAccessoires.accessoires.findIndex(
                    findMatchingShelvesDouble
                  )
                ],
                "amount",
                numberOfTwoDoorSystems * this.$store.state.shelvesPerDoor + Math.floor(numberOfOneDoorSystems / 2) * this.$store.state.shelvesPerDoor
              );
            } else if (this.$store.state.shelvesSingleDouble == "single") {
              this.$set(
                computedAccessoires.accessoires[
                  computedAccessoires.accessoires.findIndex(
                    findMatchingShelvesSingle
                  )
                ],
                "amount",
                numberOfOneDoorSystems * this.$store.state.shelvesPerDoor + 2 * numberOfTwoDoorSystems *
                  this.$store.state.shelvesPerDoor
              );
            }
          }
        }

        // Amount of shelves added
        const sumOfShelvesReducer = (accumulator, currentValue) =>
            currentValue["type"] == 'shelves'
            ? accumulator + currentValue["amount"]
            : accumulator;

        let sumOfShelves = computedAccessoires.accessoires.reduce(
          sumOfShelvesReducer,
          0
        );

        const sumOfSingleShelvesReducer = (accumulator, currentValue) =>
            currentValue["type"] == 'shelves' && currentValue["single_double"]=="single"
            ? accumulator + currentValue["amount"]
            : accumulator;
        let sumOfSingleShelves = computedAccessoires.accessoires.reduce(
          sumOfSingleShelvesReducer,
          0
        );
        const sumOfDoubleShelvesReducer = (accumulator, currentValue) =>
            currentValue["type"] == 'shelves'&& currentValue["single_double"]=="double"
            ? accumulator + currentValue["amount"]
            : accumulator;
        let sumOfDoubleShelves = computedAccessoires.accessoires.reduce(
          sumOfDoubleShelvesReducer,
          0
        );
        // Price Labels
        const findPriceLabelsPlateSingle = (element) => (
          element.type == "price labels" &&
          element.single_double == "single" &&
          element.plate_wire == this.$store.getters.shelvesWirePlate
        );
        const findPriceLabelsPlateDouble = (element) => (
          element.type == "price labels" &&
          element.single_double == "double" &&
          element.plate_wire == this.$store.getters.shelvesWirePlate
        );
        const findPriceLabelsWire = (element) => (
          element.type == "price labels" &&
          element.plate_wire == this.$store.getters.shelvesWirePlate
        );
        const findPriceLabelsWireSpecial = (element) => (
          element.type == "price label special"
        );
        if (this.$store.state.shelvesWirePlate == 'wire') {
          if (['45', '90'].includes(this.$store.state.article.slice(-2))) {
            this.$set(
              computedAccessoires.accessoires[
                computedAccessoires.accessoires.findIndex(findPriceLabelsWire)
              ],
              "amount",
              sumOfDoubleShelves
            )
          }
          else if (
            ['view', 'tview'].includes(this.$store.state.coldroomSystem) && this.$store.state.shelvesSingleDouble == "double" && this.$store.state.article.slice(-2) == "66"
          ) {
            this.$set(
              computedAccessoires.accessoires[
                computedAccessoires.accessoires.findIndex(findPriceLabelsWire)
              ],
              "amount",
              sumOfDoubleShelves + sumOfSingleShelves
            );
            this.$set(
              computedAccessoires.accessoires[
                computedAccessoires.accessoires.findIndex(findPriceLabelsWireSpecial)
              ],
              "amount",
              sumOfDoubleShelves
            );
          }
          else {
            this.$set(
              computedAccessoires.accessoires[
                computedAccessoires.accessoires.findIndex(findPriceLabelsWire)
              ],
              "amount",
              sumOfSingleShelves + 2*sumOfDoubleShelves
            );
          }
        } else {
          // Special case of 45, since it has no single shelves
          if (['45', '90'].includes(this.$store.state.article.slice(-2))) {
            this.$set(
              computedAccessoires.accessoires[
                computedAccessoires.accessoires.findIndex(findPriceLabelsPlateDouble)
              ],
              "amount",
              sumOfDoubleShelves
            );
          } else {
            this.$set(
              computedAccessoires.accessoires[
                computedAccessoires.accessoires.findIndex(findPriceLabelsPlateSingle)
              ],
              "amount",
              sumOfSingleShelves
            );
            this.$set(
              computedAccessoires.accessoires[
                computedAccessoires.accessoires.findIndex(findPriceLabelsPlateDouble)
              ],
              "amount",
              sumOfDoubleShelves
            );
          }
        }

        // Brackets
        const findBrackets = (element) => element.type == "brackets";
        this.$set(
          computedAccessoires.accessoires[
            computedAccessoires.accessoires.findIndex(findBrackets)
          ],
          "amount",
          sumOfShelves * 2
        );

        // Front Stops and Plexglass
        const findFrontStops = (element) => element.type == "front stops";
        const findPlexiglassSingle = (element) => (
          element.type == "plexiglass" &&
          element.single_double == "single"
        );
        const findPlexiglassDouble = (element) => (
          element.type == "plexiglass" &&
          element.single_double == "double"
        );
        if (this.$store.state.shelvesWirePlate == 'wire') {
          this.$set(
            computedAccessoires.accessoires[
              computedAccessoires.accessoires.findIndex(findFrontStops)
            ],
            "amount",
            Math.ceil(sumOfShelves * this.$store.getters.frontStopsPerShelf / 10)
          );
        } else if (this.$store.state.shelvesWirePlate == 'plate'){
          // Special case of 45, since it has no single shelves
          if (['45', '90'].includes(this.$store.state.article.slice(-2))) {
            this.$set(
              computedAccessoires.accessoires[
                computedAccessoires.accessoires.findIndex(findPriceLabelsPlateDouble)
              ],
              "amount",
              sumOfDoubleShelves
            )
          } else {
            this.$set(
              computedAccessoires.accessoires[
                computedAccessoires.accessoires.findIndex(findPlexiglassSingle)
              ],
              "amount",
              sumOfSingleShelves
            );
            this.$set(
              computedAccessoires.accessoires[
                computedAccessoires.accessoires.findIndex(findPlexiglassDouble)
              ],
              "amount",
              sumOfDoubleShelves
            );
          }
        }

        // Dividers
        const findDividers = (element) => (
          element.type == "dividers" &&
          element.plate_wire == this.$store.getters.shelvesWirePlate
        );
        this.$set(
          computedAccessoires.accessoires[
            computedAccessoires.accessoires.findIndex(findDividers)
          ],
          "amount",
          Math.ceil(sumOfShelves * this.$store.getters.dividersPerShelf / 10)
        );

        // Posts
        const findPosts = (element) => element.type == "posts";
        if (this.$store.state.coldroomSystem == "classic") {
          if (this.$store.state.shelvesSingleDouble == "single") {
            this.$set(
              computedAccessoires.posts[
                computedAccessoires.posts.findIndex(findPosts)
              ],
              "amount",
              this.$store.state.numberOfSystems + numberOfDoors
            );
          } else if (this.$store.state.shelvesSingleDouble == "double") {
            // Special case of 45, since it has no single shelves
            if (this.$store.state.article.slice(-2) == "45") {
              if (this.$store.state.numberOfSystems > 0) {
                this.$set(
                  computedAccessoires.posts[
                    computedAccessoires.posts.findIndex(findPosts)
                  ],
                  "amount",
                  this.$store.state.numberOfSystems + 1
                );
              } else if (this.$store.state.numberOfSystems == 0) {
                this.$set(
                  computedAccessoires.posts[
                    computedAccessoires.posts.findIndex(findPosts)
                  ],
                  "amount",
                  0
                );
              }
            }
            // Special case of 90, since it uses 45 shelves
            else if (this.$store.state.article.slice(-2) == "90"){
              if (this.$store.state.numberOfSystems > 0) {
                this.$set(
                  computedAccessoires.posts[
                    computedAccessoires.posts.findIndex(findPosts)
                  ],
                  "amount",
                  numberOfDoors+1
                );
              } else if (this.$store.state.numberOfSystems == 0) {
                this.$set(
                  computedAccessoires.posts[
                    computedAccessoires.posts.findIndex(findPosts)
                  ],
                  "amount",
                  0
                );
              }
            }
            else {
              this.$set(
                computedAccessoires.posts[
                  computedAccessoires.posts.findIndex(findPosts)
                ],
                "amount",
                this.$store.state.numberOfSystems + doubleShelvesNeeded + singleShelvesNeeded
              );
            }
          }
        } else if (['view', 'tview'].includes(this.$store.state.coldroomSystem)) {
          if (this.$store.state.shelvesSingleDouble == "single") {
            if (this.$store.state.article.slice(-2)=="66"){
              this.$set(
                computedAccessoires.posts[
                  computedAccessoires.posts.findIndex(findPosts)
                ],
                "amount",
                numberOfDoors*2
              );
            } else {
              if (this.$store.state.numberOfSystems > 0) {
                if (['76'].includes(this.$store.state.article.slice(-2))){
                  this.$set(
                    computedAccessoires.posts[
                      computedAccessoires.posts.findIndex(findPosts)
                    ],
                    "amount",
                    numberOfTwoDoorSystems *3  + Math.max(numberOfOneDoorSystems + 1 + Math.floor(numberOfOneDoorSystems/ 2 - 0.5), 0)
                  );
                } else {
                  this.$set(
                    computedAccessoires.posts[
                      computedAccessoires.posts.findIndex(findPosts)
                    ],
                    "amount",
                    numberOfDoors + 1
                  );
                }
              } else if (this.$store.state.numberOfSystems == 0) {
                this.$set(
                  computedAccessoires.posts[
                    computedAccessoires.posts.findIndex(findPosts)
                  ],
                  "amount",
                  0
                );
              }
            }
          } else {
            if (this.$store.state.numberOfSystems > 0) {
              if(numberOfTwoDoorSystems > 0){
                this.$set(
                  computedAccessoires.posts[
                    computedAccessoires.posts.findIndex(findPosts)
                  ],
                  "amount",
                  numberOfTwoDoorSystems + Math.floor(numberOfOneDoorSystems / 2) + 1 + (numberOfOneDoorSystems % 2)
                );
              } else {
                  this.$set(
                  computedAccessoires.posts[
                    computedAccessoires.posts.findIndex(findPosts)
                  ],
                  "amount",
                  Math.floor(numberOfOneDoorSystems / 2) + 1 + (numberOfOneDoorSystems % 2)
                );
              }
            } else if (this.$store.state.numberOfSystems == 0) {
              this.$set(
                  computedAccessoires.posts[
                    computedAccessoires.posts.findIndex(findPosts)
                  ],
                  "amount",
                  0
                );
            }
          }
        }
        // Flanges
        const findFlanges = (element) => (
          element.type == "flange"
          &&
          element.height == chosenHeight
        );
        if (['view', 'tview'].includes(this.$store.state.coldroomSystem) & this.$store.state.numberOfSystems > 0) {
          this.$set(
            computedAccessoires.posts[
              computedAccessoires.posts.findIndex(findFlanges)
            ],
            "amount",
            1
          );
        }
        // Adjoiners
        if (this.$store.state.coldroomSystem == "classic" && this.$store.state.article.slice(-2) != "45") {

          const height = systems[0]['Height'];

          const findAdjoiners = (element) => {
            if (height != 1844) {
              return element.type == "adjoiners" &&
              element.height == height
            } else if (height == 1844){
              return element.type == "adjoiners" &&
              element.height == 1944
            }
          };

          this.$set(
            computedAccessoires.posts[
              computedAccessoires.posts.findIndex(findAdjoiners)
            ],
            "amount",
            Math.max(this.$store.state.numberOfSystems - 1, 0)
          );
        }
        // Lighting
        if (['view', 'tview'].includes(this.$store.state.coldroomSystem)) {
          const findSideLights = (element) => element.type == "side";
          const findTopLongLights = (element) => element.type == "top_long";
          const findTopMidLights = (element) => element.type == "top_mid";
          const findTopShortLights = (element) => element.type == "top_short";
          const findCenterLights = (element) => element.type == "center";
          const findPowerSupply = (element) => element.type == "power_supply";
          //Set Side Lights
          if (this.$store.state.numberOfSystems > 0) {
            this.$set(
              computedAccessoires.lighting[
                computedAccessoires.lighting.findIndex(findSideLights)
              ],
              "amount",
              2
            );
          } else {
            this.$set(
              computedAccessoires.lighting[
                computedAccessoires.lighting.findIndex(findSideLights)
              ],
              "amount",
              0
            );
          }
          //Set Center Lights
          this.$set(
            computedAccessoires.lighting[
              computedAccessoires.lighting.findIndex(findCenterLights)
            ],
            "amount",
            Math.max(this.$store.state.numberOfSystems - 1, 0)
          );
          //Set Top Lights
          if (this.$store.state.article.slice(-2) == "45"){
            if (this.$store.state.numberOfSystems == 1) {
              if (numberOfOneDoorSystems == 1) {
                this.$set(
                  computedAccessoires.lighting[
                    computedAccessoires.lighting.findIndex(findTopShortLights)
                  ],
                  "amount",
                  1
                );
              } else if (numberOfTwoDoorSystems == 1) {
                this.$set(
                  computedAccessoires.lighting[
                    computedAccessoires.lighting.findIndex(findTopMidLights)
                  ],
                  "amount",
                  1
                );
              }
            } else if (this.$store.state.numberOfSystems > 1) {
              if (numberOfOneDoorSystems > 1) {
                this.$set(
                  computedAccessoires.lighting[
                    computedAccessoires.lighting.findIndex(findTopMidLights)
                  ],
                  "amount",
                  numberOfTwoDoorSystems - 1
                );
                this.$set(
                  computedAccessoires.lighting[
                    computedAccessoires.lighting.findIndex(findTopLongLights)
                  ],
                  "amount",
                1
                );
              } else if (numberOfOneDoorSystems == 0) {
                this.$set(
                  computedAccessoires.lighting[
                    computedAccessoires.lighting.findIndex(findTopMidLights)
                  ],
                  "amount",
                  numberOfTwoDoorSystems
                );
              }
            } else if (this.$store.state.numberOfSystems == 0 ) {
               this.$set(
                  computedAccessoires.lighting[
                    computedAccessoires.lighting.findIndex(findTopMidLights)
                  ],
                  "amount",
                  0
               );
            }
          } else {
            this.$set(
              computedAccessoires.lighting[
                computedAccessoires.lighting.findIndex(findTopLongLights)
              ],
              "amount",
              numberOfTwoDoorSystems
            );
            this.$set(
              computedAccessoires.lighting[
                computedAccessoires.lighting.findIndex(findTopShortLights)
              ],
              "amount",
              numberOfOneDoorSystems
            );
          }
          //Power
          const sumOfWattReducer = (accumulator, currentValue) =>
            currentValue["type"] != "power_supply"
              ? accumulator + currentValue["amount"] * currentValue["Watt"]
              : accumulator;
          let sumOfWatt = computedAccessoires.lighting.reduce(
            sumOfWattReducer,
            0
          );
          if (this.$store.state.numberOfSystems > 0) {
            this.$set(
              computedAccessoires.lighting[
                computedAccessoires.lighting.findIndex(findPowerSupply)
              ],
              "amount",
              Math.floor(sumOfWatt / 85) + 1
            );
          }
          else if (this.$store.state.numberOfSystems == 0) {
            this.$set(
              computedAccessoires.lighting[
                computedAccessoires.lighting.findIndex(findPowerSupply)
              ],
              "amount",
              0
            );
          }
        }
        // Gravity Sheet
        const findGravitySheet = (element) => element.type == "gravity sheet";
        if (this.$store.getters.shelvesWirePlate == 'wire') {
          if (this.$store.getters.gravitySheetSwitch) {
            this.$set(
              computedAccessoires.accessoires[
                computedAccessoires.accessoires.findIndex(findGravitySheet)
              ],
              "amount",
              sumOfSingleShelves + sumOfDoubleShelves*2
            );
          } else {
            this.$set(
              computedAccessoires.accessoires[
                computedAccessoires.accessoires.findIndex(findGravitySheet)
              ],
              "amount",
              0
            );
          }
        } else {
          this.$set(
            computedAccessoires.accessoires[
              computedAccessoires.accessoires.findIndex(findGravitySheet)
            ],
            "amount",
            0
          );
        }
        // Container Stops
        // Set to same amount as double shelves, as the calculation is the same
        const findContainerStops = (element) => element.type == "container stop";
        if (this.$store.getters.containerStops) {
          this.$set(
            computedAccessoires.accessoires[
              computedAccessoires.accessoires.findIndex(findContainerStops)
            ],
            "amount",
            doubleShelvesNeeded
          );
        } else {
          this.$set(
            computedAccessoires.accessoires[
              computedAccessoires.accessoires.findIndex(findContainerStops)
            ],
            "amount",
            0
          );
        }
       return computedAccessoires;
      },
      set(computedAccessoires){
        this.$store.commit("setComputedAccessoires",computedAccessoires);
      }
    }
  }
};
</script>
